import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs'

const areaFilterParsers = {
  search: parseAsString.withDefault('').withOptions({ clearOnDefault: true }),
  isActive: parseAsArrayOf(parseAsString, ',')
    .withDefault(['all'])
    .withOptions({ clearOnDefault: true }),
  type: parseAsArrayOf(parseAsString, ',')
    .withDefault(['all'])
    .withOptions({ clearOnDefault: true }),
}

export function useAreaFilters() {
  const [filters, setFilters] = useQueryStates(areaFilterParsers, {
    history: 'replace',
    shallow: true,
  })

  const updateSearch = (search: string) => {
    const v = search.trim()
    setFilters({ search: v === '' ? null : v })
  }

  const updateAreaType = (types: string[]) => {
    setFilters({ type: types && types.length ? types : null })
  }

  const updateAreaStatus = (statuses: string[]) => {
    setFilters({ isActive: statuses && statuses.length ? statuses : null })
  }

  const clearAllFilters = () => {
    setFilters({
      search: null,
      isActive: null,
      type: null,
    })
  }

  const hasActiveFilters =
    filters.search.trim() !== '' ||
    !filters.isActive.includes('all') ||
    !filters.type.includes('all')

  return {
    filters,
    updateSearch,
    updateAreaType,
    updateAreaStatus,
    clearAllFilters,
    hasActiveFilters,
  }
}

// Tipos
export type AreaFilters = ReturnType<typeof useAreaFilters>['filters']
export type AreaFilterKey = keyof typeof areaFilterParsers
